import React from "react";
import { PRODUCT_IMG } from "./productImages";

export const ProductOrbit = ({ items, step, onPick }) => {
  const n = items.length;
  const angle = 360 / n;
  const active = ((step % n) + n) % n;
  return (
    <div className="pp-orbit-stage" data-testid="hero-product-orbit">
      <div className="pp-orbit-tilt">
        <div className="pp-orbit-floor" />
        <div className="pp-orbit-ring" style={{ transform: `rotateY(${-step * angle}deg)` }}>
          {items.map((p, i) => {
            const on = i === active;
            return (
              <div key={p.name} className="pp-orbit-item" style={{ transform: `rotateY(${i * angle}deg) translateZ(var(--r))` }}>
                <div className="pp-orbit-face" style={{ transform: `rotateY(${-i * angle + step * angle}deg)` }}>
                  <button
                    onClick={() => onPick(i)}
                    data-testid={`hero-orbit-item-${i}`}
                    aria-label={p.name}
                    className={`pp-orbit-float ${on ? "is-active" : ""}`}
                    style={{ animationDelay: `${-i * 0.6}s` }}
                  >
                    <img src={PRODUCT_IMG[p.img]} alt={p.name} className="pp-orbit-img" />
                    <span className="pp-orbit-label">{p.name}</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
